import React, { useState } from 'react';

const EyeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12Z" />
    <circle cx="12" cy="12" r="3" />
  </svg>
);

const EyeOffIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M2 12s3.5-6 10-6c2.12 0 3.95 0.64 5.48 1.53" />
    <path d="M22 12s-3.5 6-10 6c-2.1 0-3.94-0.64-5.47-1.53" />
    <path d="M14.12 14.12A3 3 0 0 1 9.88 9.88" />
    <path d="M3 3l18 18" />
  </svg>
);

const PasswordField = (props) => {
  const { disabled, ...inputProps } = props;
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div className="input-shell input-shell--password">
      <input
        {...inputProps}
        type={isVisible ? 'text' : 'password'}
        disabled={disabled}
      />
      <button
        type="button"
        className="password-toggle"
        aria-label={isVisible ? 'Hide characters' : 'Show characters'}
        aria-pressed={isVisible}
        onClick={() => setIsVisible((visible) => !visible)}
        disabled={disabled}
      >
        {isVisible ? <EyeOffIcon /> : <EyeIcon />}
      </button>
    </div>
  );
};

export default PasswordField;
